import React from "react";
import { bool, func } from "prop-types";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomText from "pages/_components/CustomText/CustomText";

// import I18n from "pages/_components/I18n";

const EnvironmentExitSlide = ({ slideIsVisible, closeSlide }) => (
    <Drawer className="qr-slider" openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
        <div className="container">
            <h2 className="title-content">
                <CustomText text="¿Estás seguro de querer abandonar la operación?" />
            </h2>
        </div>
    </Drawer>
);

EnvironmentExitSlide.propTypes = {
    slideIsVisible: bool.isRequired,
    closeSlide: func.isRequired,
};

export default EnvironmentExitSlide;
